import workPeriod from './workPeriod';
import VueRouter from 'vue-router';

export default {
    data: () => ({periodGuardPending: false, periodNavigationError: ''}),
    beforeRouteUpdate(to, from, next) {
        if (to.fullPath === this._canonicalPeriodPath || this.samePeriodRoute && this.samePeriodRoute(to)) { next(); return; }
        this.confirmPeriodLeave().then(allowed => next(allowed ? undefined : false));
    },
    beforeRouteLeave(to, from, next) {
        // The list and a loaded sheet use different route records for the same workspace.
        // Updating that sheet's URL must not discard or re-check restored drafts.
        if (to.fullPath === this._canonicalPeriodPath) { next(); return; }
        this.confirmPeriodLeave().then(allowed => next(allowed ? undefined : false));
    },
    beforeDestroy() {
        this._periodNavigationSequence = (this._periodNavigationSequence || 0) + 1;
        this._canonicalPeriodPath = null;
    },
    methods: {
        reportPeriodNavigationError(error, phase) {
            this.periodNavigationError = phase === 'leave'
                ? 'Не удалось проверить несохранённые изменения. Данные оставлены на странице. Повторите переход.'
                : 'Не удалось обновить адрес страницы. Загруженные данные и несохранённые изменения оставлены на экране.';
            // Do not log Axios requests, headers or response bodies.
            console.error('[WorkPeriodNavigation]', phase, error && error.name, error && error.message);
        },
        async confirmPeriodLeave() {
            this.periodNavigationError = '';
            try { return await this.preparePeriodLeave(); }
            catch (error) { this.reportPeriodNavigationError(error, 'leave'); return false; }
        },
        periodStorage() {
            try { return window.sessionStorage; } catch (error) { return null; }
        },
        savedPeriod(section) {
            return workPeriod.readContext(this.periodStorage(), this.$store.getters.currentUser, section);
        },
        rememberPeriod(section, value) {
            workPeriod.rememberContext(this.periodStorage(), this.$store.getters.currentUser, section, value);
        },
        resolvePeriod(section, queryMonth) {
            // Section entry uses its calendar default. Explicit links retain the selected period.
            return workPeriod.resolveMonth({section, queryMonth});
        },
        async pushPeriodRoute(target, replace = false) {
            const sequence = this._periodNavigationSequence = (this._periodNavigationSequence || 0) + 1;
            this._canonicalPeriodPath = null;
            this.periodNavigationError = '';
            try {
                if (replace) this._canonicalPeriodPath = this.$router.resolve(target).route.fullPath;
                await this.$router[replace ? 'replace' : 'push'](target);
                return true;
            }
            catch (error) {
                const types = VueRouter.NavigationFailureType;
                if (![types.duplicated, types.aborted, types.cancelled]
                    .some(type => VueRouter.isNavigationFailure(error, type))) {
                    if (sequence === this._periodNavigationSequence) this.reportPeriodNavigationError(error, 'url');
                    throw error;
                }
                return VueRouter.isNavigationFailure(error, types.duplicated);
            }
            finally {
                if (replace) await this.$nextTick();
                if (sequence === this._periodNavigationSequence) this._canonicalPeriodPath = null;
            }
        },
        async syncPeriodRoute(target, replace = true) {
            // URL synchronization is not a data fetch: its failure must not clear a loaded workspace.
            try { return await this.pushPeriodRoute(target, replace); }
            catch (error) { return false; }
        }
    }
};
